// The below Enum types do not represent all available options, but rather just those
// that are explicitly defined in the code base. See response from get-types
// endpoint for complete list of available Variant Types
// See https://github.com/mobilefirstdev/budsense-shared/blob/dev/models/DTO/Enum/VariantType.go for all options
//
export enum VariantType {
  // Accessories
  Battery = 'Battery',
  Bong = 'Bong',
  Book = 'Book',
  Cleaning = 'Cleaning',
  Grinder = 'Grinder',
  Kitchenware = 'Kitchenware',
  Lighter = 'Lighter',
  Pipe = 'Pipe',
  Storage = 'Storage',
  Tray = 'Tray',
  // Beverage
  Beverage = 'Beverage',
  Dissolvable = 'Dissolvable',
  Distilled = 'Distilled',
  Tea = 'Tea',
  // Edible
  Edible = 'Edible',
  Gummy = 'Gummy',
  Chocolate = 'Chocolate',
  Baking = 'Baking',
  HardCandy = 'Hard Candy',
  Sublingual = 'Sublingual',
  FrozenTreats = 'Frozen Treats',
  // Flower - By Gram
  Flower = 'Flower',
  BulkFlower = 'Bulk Flower',
  MilledFlower = 'Milled Flower',
  InfusedFlower = 'Infused Flower',
  InfusedBulkFlower = 'Infused Bulk Flower',
  FreeRoll = 'Free Roll', // US Only
  Shake = 'Shake', // US Only
  // Flower - By Unit
  PreRoll = 'Pre-Roll',
  InfusedPreRoll = 'Infused Pre-Roll',
  InfusedBlunt = 'Infused Blunt',
  Blunt = 'Blunt',
  // Oil
  Oil = 'Oil',
  Capsule = 'Capsule',
  // Other
  Apparel = 'Apparel',
  Bundle = 'Bundle',
  GiftCard = 'Gift Card',
  Merch = 'Merch',
  Other = 'Other',
  Pet = 'Pet',
  Sample = 'Sample',
  Hemp = 'Hemp',
  // Seed
  Seed = 'Seed',
  // Vape
  Vape = 'Vape',
  DisposableVape = 'Disposable Vape',
  VapeKit = 'Vape Kit',
  VapeCartridge = 'Vape Cartridge',
  Cartridge510 = '510 Cartridge', // Enum on backend is 510Cartridge but cant start with a number
  CartridgePod = 'Pod Cartridge',
  // Wellness
  Bath = 'Bath',
  CreamAndLotion = 'Cream & Lotion',
  Lubricant = 'Lubricant',
  RollOn = 'Roll-On',
  SkinCare = 'Skin Care',
  Suppository = 'Suppository',
  Transdermal = 'Transdermal'
}
